//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';

export default {
	name: 'CampaignCard',
	props: {
		campaign: {
			type: Object,
			required: true,
		},
	},
	computed: {
		...mapState('auth', ['currentUser']),
	},
	map: null,
	bounds: null,
	async mounted() {
		await window.googleApi;
		this.createMap();
		this.campaign.locations.forEach((location) => {
			this.createMarker(location);
		});
		this.$options.map.fitBounds(this.$options.bounds, -100);
	},
	methods: {
		createMap() {
			this.$options.map = new window.google.maps.Map(this.$refs.map, {
				zoom: 10,
				clickableIcons: false,
				fullscreenControl: false,
				mapTypeControl: false,
				streetViewControl: false,
			});
			this.$options.bounds = new window.google.maps.LatLngBounds();
		},
		createMarker({ lat, lng, range }) {
			new window.google.maps.Marker({
				position: { lat, lng },
				map: this.$options.map,
				draggable: false,
			});

			const circle = new window.google.maps.Circle({
				strokeColor: '#1635fb',
				strokeWeight: 2,
				fillColor: '#1635fb',
				fillOpacity: 0.3,
				map: this.$options.map,
				center: { lat, lng },
				radius: range * 1000,
			});

			this.$options.bounds.union(circle.getBounds());
		},
	},
};
